import React from 'react';
import { sortBy } from 'lodash';
import { connect } from 'react-redux';
import { selectors as groupSelectors } from '../../../../state/modules/groups';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, groups, widgetSettings: { groupIds } }) => {
  // Generate the collection of groups for the group select
  const options = sortBy(groups, ['name']).filter(g => g.type !== 'team');

  // Chooses which elements to display as selected in the select input
  const selectedOptions = options.filter(group => groupIds.includes(group.id));

  const handleChange = events => {
    const values = events.map(e => e.value);
    updateWidgetSettingsField('groupIds', values);
  };

  return (
    <SettingsForm>
      <SettingsForm.GroupSelector
        label={I18n.t('activerecord.models.group')}
        groups={options}
        value={selectedOptions}
        onChange={handleChange}
        isClearable={true}
        isMulti={true}
      />
    </SettingsForm>
  );
};

const mapStateToProps = state => ({
  groups: groupSelectors.values(state)
});

export default connect(mapStateToProps)(Settings);
